module.exports = __webpack_public_path__ + "static_portal/img/negative_arms_speed_w_arrow.314d5549.jpg";